import { render } from "./ProductUpdateModal.vue?vue&type=template&id=914c0f78"
import script from "./ProductUpdateModal.vue?vue&type=script&lang=js"
export * from "./ProductUpdateModal.vue?vue&type=script&lang=js"
script.render = render

export default script